import { TikTokBusinessConnection, TikTokBusinessService } from '@/app/services/tiktok-business/tiktok-business.service';
import { Component, inject, OnInit, signal } from '@angular/core';
import { CurrentUserService } from '@/app/common/current-user/current-user.service';
import { CreateSparkCampaign } from '../../service/create-spark-campaign/create-spark-campaign';

@Component({
  selector: 'bttv2-advertising-advertiser-id',
  imports: [],
  templateUrl: './advertising-advertiser-id.html',
  styleUrl: './advertising-advertiser-id.css',
})
export class AdvertisingAdvertiserId implements OnInit {

  connection = signal<TikTokBusinessConnection | null>(null);
  singleAdvertiserAccount = signal<string | undefined>(undefined);
  multipleAdvertiserAccounts = signal<string[] | undefined>(undefined);

  /** Services */
  private tiktokBusinessService = inject(TikTokBusinessService);
  private currentUserService = inject(CurrentUserService);
  public createSparkCampaignService = inject(CreateSparkCampaign);
  /** Services - END */


  ngOnInit(): void {
    console.log('AdvertisingAdvertiserId - ngOnInit() ---> ');

    const businessAccountId = this.currentUserService.focussedBrand?.id;

    console.log('AdvertisingAdvertiserId - businessAccountId: ', businessAccountId);

    this.tiktokBusinessService.getConnection(businessAccountId).subscribe({
      next: (conn) => {
        this.connection.set(conn);
        console.log('AdvertisingAdvertiserId - connection: ', this.connection());
        this.singleAdvertiserAccount.set(conn?.advertiserAccountId ?? undefined);
        this.multipleAdvertiserAccounts.set(conn?.advertiserAccountIds ?? undefined);

        if (this.singleAdvertiserAccount() !== undefined) {
          this.createSparkCampaignService.selectedAdvertiserAccountId.set(this.singleAdvertiserAccount()!);
        }
        // this.loading.set(false);
      },
      error: () => {
        this.connection.set(null);
        // this.loading.set(false);
      },
    });
  }

  selectAdvertiserAccount(accountId: string): void {
    this.createSparkCampaignService.selectedAdvertiserAccountId.set(accountId);
  }

  getAdvertiserAccountClass(accountId: string): string {
    return this.createSparkCampaignService.selectedAdvertiserAccountId() === accountId ? 'bg-primary text-white dark:bg-primary/20 dark:text-white' : 'bg-gray-50 text-gray-600 dark:bg-gray-400/10 dark:text-gray-400';
  }
}
